var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFbMessengerDs = function SvgFbMessengerDs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.4775 0 0 4.14583 0 9.25917C0 12.1733 1.45417 14.7725 3.72667 16.4692V20L7.13167 18.1317C8.04 18.3825 9.00333 18.5183 10 18.5183C15.5225 18.5183 20 14.3733 20 9.25917C20 4.14583 15.5225 0 10 0ZM10.9942 12.4692L8.4475 9.75333L3.47833 12.4692L8.94417 6.66667L11.5525 9.3825L16.46 6.66667L10.9942 12.4692Z",
    fill: "#1B1E27"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFbMessengerDs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fb-messenger-ds.265fb44973b63873a4f1ce1c04540bd2.svg";